<template>
  <div class="ui-content dashboard res-analisis-page health-card">
    <v-card class="mx-auto normal-card autohg ProgressBarSubcard">
      <div class="user-data">
        <v-row>
          <v-col cols="12" sm="12" class="bottom-border">
            <div class="show-drop-down">
              <div class="label-data">Select Center</div>
              <div class="field-data">
                <v-select
                  :items="centers"
                  hide-details
                  dense
                  class="fix-200"
                  v-model="selectedCenterId"
                  @change="getListOfBatches"
                  filled
                ></v-select>
              </div>
            </div>
            <div class="show-drop-down">
              <div class="label-data">Select Batch</div>
              <div class="field-data">
                <v-select
                  :items="batches"
                  hide-details
                  dense
                  class="fix-200"
                  @change="getBatchWiseHealthList"
                  v-model="selectedBatch"
                  filled
                ></v-select>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
      <div class="analysis-block result-card-section ProgressBarSub">
        <div
          class="cust-rw row-I"
          v-for="subject in subjectWiseData"
          :key="subject.id"
        >
          <div class="col-I">
            <div class="sub-title">{{ subject.name }}:</div>
          </div>
          <div class="col-II">
            <div class="progress-bar" v-if="!subject.showChapterWise">
              <ProgressBar :height="25" :value="subject.healthPercentage" />
            </div>
            <div class="analysis-card" v-else>
              <v-card>
                <div
                  class="progress-block"
                  v-for="chapter in subject.chapters"
                  :key="chapter.key"
                >
                  <div class="chapter_title">
                    <div class="chapter_name">{{ chapter.name }}</div>
                  </div>
                  <div class="progress-bar">
                    <ProgressBar
                      :height="25"
                      :value="chapter.healthPercentage"
                    />
                  </div>
                </div>
              </v-card>
            </div>
          </div>
          <div class="col-III">
            <div class="add-progress">
              <v-icon
                @click="subject.showChapterWise = true"
                v-if="!subject.showChapterWise"
                >mdi-plus-circle</v-icon
              >
              <v-icon @click="subject.showChapterWise = false" v-else
                >mdi-minus-circle</v-icon
              >
            </div>
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import ProgressBar from "@/components/common/ProgressBar.vue";
export default {
  name: "BatchHealth",
  mounted() {
    this.checkSessionData();
  },
  components: {
    ProgressBar,
  },
  data() {
    return {
      centers: [],
      batches: [],
      selectedCenterId: 0,
      selectedBatch: 0,
      subjectWiseData: [],
      isLoadedFirstTime: false,
      isCenterFirstTime: true,
      isBatchFirstTime: true,
      isLoadingFirstTime: true,
    };
  },
  methods: {
    ...mapActions({
      getCenters: "centerAndBatchStore/getCenters",
      getBatches: "centerAndBatchStore/getBatches",
      getBatchWiseHealth: "resultStore/getBatchWiseHealth",
    }),
    updateRouteDetails(details) {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      if (crd.tabDetails[crd.selectedTab]) {
        switch (details.type) {
          case "centerIds":
            crd.tabDetails[crd.selectedTab].centerIds = details.data.centerIds;
            break;
          case "batchIds":
            crd.tabDetails[crd.selectedTab].batchIds = details.data.batchIds;
            break;
          default:
            break;
        }
      }
      this.setRouteDetails(crd);
    },
    defaultData() {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      if (crd) {
        this.selectedCenterId = crd.tabDetails[crd.selectedTab].centerIds; // load center ids from session
        this.selectedBatch = crd.tabDetails[crd.selectedTab].batchIds; // load batches in session
      }
      this.requestGetCenters();
    },
    checkSessionData() {
      let rp = this.$route; // route params
      let crd = this.getCurrentRouteDetails(rp.name);

      if (rp.params.resetPage || !crd.routeName) {
        let tabDetail = {
          default: { page: 1, centerIds: null, batchIds: null },
        };
        let routeDetails = {
          routeName: rp.name,
          selectedTab: "default",
          tabDetails: tabDetail,
        };
        this.setRouteDetails(routeDetails);
      }
      this.defaultData();
      // this.getTestList();
    },
    getColor(percentage) {
      let color = "";
      if (percentage > 65) {
        color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.GREEN;
      } else if (percentage > 19) {
        color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.ORANGE;
      } else {
        color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.RED;
      }
      return color;
    },
    resetPage() {
      this.currentPage = 1;
      this.updateCurrentPageInSession(1);
    },
    getListOfBatches() {
      this.subjectWiseData = [];
      if (!this.isLoadingFirstTime) this.resetPage();
      // this.selectedBatch = null;
      this.$root.showLoader = true;
      this.updateRouteDetails({
        type: "centerIds",
        data: { centerIds: this.selectedCenterId },
      });
      this.getBatches({ center_id: [this.selectedCenterId] })
        .then((response) => {
          this.$root.showLoader = false;

          if (response && response.list && response.list.length) {
            this.batches = response.list.map((x) => {
              let c = {};
              c.text = x.name;
              c.value = x.id;
              return c;
            });
            if (!(this.isBatchFirstTime && this.selectedBatch)) {
              this.selectedBatch = this.batches[0].value;
            }
            this.getBatchWiseHealthList();
            // if (!this.isLoadedFirstTime) {
            //     this.isLoadedFirstTime = true;
            //     this.selectedBatch = this.batches[0].value;
            //     this.getBatchWiseHealthList();
            // }
          } else {
            this.batches = [];
          }
          this.isBatchFirstTime = false;
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    requestGetCenters() {
      this.$root.showLoader = true;
      if (!this.isLoadingFirstTime) this.resetPage();
      this.getCenters()
        .then((response) => {
          this.$root.showLoader = false;
          this.centers = response.map((x) => {
            let c = {};
            c.text = x.name;
            c.value = x.id;
            return c;
          });
          if (!(this.isCenterFirstTime && this.selectedCenterId)) {
            this.selectedCenterId = this.centers[0].value;
          }
          this.getListOfBatches();
          this.isCenterFirstTime = false;
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    getBatchWiseHealthList() {
      this.updateRouteDetails({
        type: "batchIds",
        data: { batchIds: this.selectedBatch },
      });
      this.subjectWiseData = [];
      let postData = {
        batch_id: this.selectedBatch,
      };
      this.$root.showLoader = true;
      this.getBatchWiseHealth(postData)
        .then((response) => {
          this.isLoadedFirstTime = false;
          if (
            response.list.length == 0 &&
            this.currentPage != 1 &&
            !this.$route.query.resetPage
          ) {
            this.onPageChange(1);
            return;
          }
          this.$root.showLoader = false;

          if (response.list && response.list.length > 0) {
            let subjectInfoList = [];
            subjectInfoList = response.list.map((subjectInfo) => {
              let subject = subjectInfo.subject;
              let subjectObj = {};
              subjectObj.name = subject.title;
              subjectObj.id = subject.id;
              subjectObj.healthPercentage = subject.health;
              subjectObj.showChapterWise = false;
              subjectObj.chapters = [];
              if (subject.children && subject.children.length > 0) {
                subjectObj.chapters = subject.children.map((chapter) => {
                  let chapterObj = [];
                  chapterObj.name = chapter.title;
                  chapterObj.id = chapter.id;
                  chapterObj.healthPercentage = chapter.health;

                  return chapterObj;
                });
              }
              return subjectObj;
            });
            this.subjectWiseData = subjectInfoList;
          }
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
  },
  watch: {},
};
</script>
